import { useEffect, useRef, useState } from 'react'
import {
  Wrapper,
  Header,
  Title,
  Column,
  ColumnWrapper,
  ChatWrapper,
  InputWrapper,
  Button,
  Input,
  MessagesWrapper,
  TitleURL,
} from './styled'
import logo from '@/assets/images/safe.png'
import ChatBox from '@pages/dashboard/messages/chat-box'
import { IChat } from './types'
import { Message, Paginator } from '@twilio/conversations'
import { useAppSelector } from '@/app/hooks'
import { ClipLoader } from 'react-spinners'

const DealChat = ({
  conversation,
  client,
  renderFlag,
  firstMessage,
  deal,
}: IChat) => {
  const [newMessage, setNewMessage] = useState('')
  const [loading, setLoading] = useState(true)
  const [messageWasSent, setMessageWasSent] = useState(false)
  const [buttonLoading, setButtonLoading] = useState(false)
  const userMail = useAppSelector((state) => state.authUser.userMail)
  const [messages, setMessages] = useState<Paginator<Message> | undefined>()
  const appEnv = process.env.APP_ENVIRONMENT

  useEffect(() => {
    if (conversation) {
      getMessages().then(() => {
        setLoading(false)
        setMessageWasSent(false)
      })
      conversation.on('messageAdded', (msg) => {
        getMessages()
      })
    }
  }, [conversation, messageWasSent])

  const truncate = (str: string, n: number) => {
    return str.length > n ? str.slice(0, n - 1) + '...' : str
  }

  const getMessages = async () => {
    try {
      setMessages(await conversation.getMessages())
    } catch {
      console.log('error')
    }
  }

  const sendMessage = async () => {
    if (newMessage && client) {
      setButtonLoading(true)
      client.getConversationBySid(conversation.sid).then((data: any) => {
        if (newMessage && String(newMessage).trim()) {
          data.sendMessage(newMessage).then(() => {
            setNewMessage('')
            setButtonLoading(false)
            setMessageWasSent(true)
          })
        } else {
          console.log('error')
        }
      })
    }
  }

  return (
    <>
      {
        <Wrapper>
          <ChatWrapper>
            <MessagesWrapper>
              {firstMessage && (
                <ChatBox
                  key={0}
                  author={userMail}
                  message={firstMessage}
                  date={deal.createdAt}
                  isAlignLeft={true}
                />
              )}
              {messages &&
                messages.items.map((message: Message, index: number) =>
                  message.author == userMail ? (
                    <ChatBox
                      key={index}
                      author={message.author}
                      message={message.body}
                      date={message.dateCreated}
                      isAlignLeft={true}
                    />
                  ) : (
                    <ChatBox
                      key={index}
                      author={message.author}
                      message={message.body}
                      date={message.dateCreated}
                      isAlignLeft={false}
                    />
                  ),
                )}
            </MessagesWrapper>
          </ChatWrapper>
          <InputWrapper>
            <Button>
              {buttonLoading ? (
                <ClipLoader color="#ffffff" loading={buttonLoading} size={15} />
              ) : (
                'Actions'
              )}
            </Button>
            <Input
              onChange={(e) => setNewMessage(e.target.value)}
              id="input"
              value={newMessage}
            />
            <Button onClick={sendMessage}>
              {buttonLoading ? (
                <ClipLoader color="#ffffff" loading={buttonLoading} size={15} />
              ) : (
                'Send message'
              )}
            </Button>
          </InputWrapper>
        </Wrapper>
      }
    </>
  )
}

export default DealChat
